import React, { useEffect, useRef, useState, useContext } from 'react';
// import ReCAPTCHA from 'react-google-recaptcha';
import LoginContext from '../../../../store/login-context';
import SMSOTP from '../SMSOTP';

import Validator from '../../../../Handler/Validator';
import eye from '../../../../assets/icons/outline_eye_bright.svg';
import eyeOff from '../../../../assets/icons/outline_eye_bright-off.svg';
import SubmitBtn from '../../../Form/submit-button/submit-button.component';
import Ajax from '../../../../Handler/Ajax';
import Toast from '../../../Form/Toast';
import GovSpinner from '../../../Form/GovSpinner';
import alert from '../../../../assets/icons/alert-circle-red.svg';
import './index.scss';
import NavigationButtons from '../../../General/Static/NavigationButtons/NavigationButtons';
import passwordImg from '../../../../assets/img/password.svg';
import passkeyImg from '../../../../assets/img/passkey.svg';
import LoginSideNote from './LoginSideNote/LoginSideNote';
import MaskInput from '../../../General/Static/MaskInput/MaskInput';
// import PushDetailsExists from '../Push/Old/PushDetailsExists';
// import PushDetailsNotExists from '../Push/Old/PushDetailsNotExists';
import PushTimeout from '../Push/Timeout/PushTimeout';
import PushCancel from '../Push/Cancel/PushCancel';
import PushVerification from '../Push/Verification/PushVerification';
import PushNotifications from '../Push/Notifications/PushNotifications';
import DynamicText from '../../../General/Static/DynamicText/DynamicText';




declare var _siteSettings: any;
declare function Translate(key: string): string;
declare var _curLang: any;
declare var _loginType: any;
declare var _loginMethodSmartphoneOtpUrl: any;
declare var _loginTypeSMSOTP: any;
declare var _loginMethodWebauthnUrl: any;
declare var _loginTypeSMSOTPSmartphoneEnrollment: any;


const Login = props => {
  let recaptchaRef:any = useRef(undefined);
  const ctx = useContext(LoginContext);

  // const [captcha, setCaptcha] = useState(true);
  // const [captchaToken, setCaptchaToken] = useState('');  
  const [userId,setUserId] = useState('');
  const [password,setPassword] = useState('');
  const [maskOtpDest,setMaskOtpDest] = useState('');
  const [maskEmailDest,setMaskEmailDest] = useState('');
  const [stage,setStage] = useState(1);
  const [loading,setLoading] = useState(false);
  const [controlType,setControlType] = useState('password');   
  const [serverMessage,setServerMessage] = useState(Translate(''));  
  const [idDirty,setIdDirty] = useState(false);
  const [passwordDirty,setPasswordDirty] = useState(false);  
  const [passwordTooltip, setPasswordToolTip] = useState(false);
  const [idBlur,setIdBlur] = useState(false);
  const [showPassKey, setShowPassKey] = useState(true);
  const [timeoutStep,setTimeoutStep] = useState(1);
  const [isPasswordAutofilled, setIsPasswordAutofilled] = useState(false);
  
  
  useEffect(() => {
    if (!ctx.devMode){
      setLoading(true);
      Ajax.InitiateLoginSequence()
        .then((res: any) => {
          setLoading(false);
          if(res.isError && res.errorCode === "LOGON_IN_PROGRESS"){
            if(res.otpDestMasked.startsWith("UB:")){
              props.updateLoginStage(3);
              setStage(3); 
            }
            else if(res.otpDestMasked.startsWith("UB2:")){
              props.updateLoginStage(4);
              setStage(4); 
            }
          }         
          else if (res.currentState != undefined && res.currentState.startsWith("updateDetails"))
          {
            ctx.setLoginNeededInfo(res.neededInfo);
            ctx.setCurrentState(res.currentState);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    } 
    
    //hide passkey button on mobile when user login first for passkey process
    let pkView = sessionStorage.getItem('showPkBtn');
    if(pkView !== undefined && pkView === 'false'){
        setShowPassKey(false);
    }
  
  },[]);

  useEffect(() => {
    if(userId.length > 0 && !idDirty){
      setIdDirty(true);      
    }   
  },[userId]);

  useEffect(() => {
    if(password.length > 0 && !passwordDirty){
      setPasswordDirty(true);
    }
  },[password]);

  // const executeCaptcha = () => {   
  //   if (captcha) {
  //     recaptchaRef.current.execute();
  //   } else {
  //     callback(captchaToken);
  //   }
  // };

  // const callback = (token) => {    
  //   setCaptcha(false);
  //   setCaptchaToken(token);  

  //   onSolve(userId, password, token)
  //     .then((res) => handleAfterClick(res))
  //     .catch((error) => handleAfterClick(error));            
  // };

  // const onCaptchaExpired = () => {
  //   setCaptcha(true);
  //   setCaptchaToken('');    
  // };

  const Submit = () => {
    setServerMessage('');
     if (!isIdValid() || !isPasswordValid()) return;

    //create custom event id for glassbox
    if(userId.length === 9){         
      const gbDetector = window['_detector']; 
      if(gbDetector){
        gbDetector.triggerCustomEvent('userIsraeliIdLogin', userId, [document.getElementById("userId")]);
      }
    }

     if (!ctx.devMode) {
        setLoading(true);
        // executeCaptcha(); 
        Ajax.FirstLoginSMS(userId, password)
        .then((res: any) => {
          setLoading(false);
          handleAfterClick(res);
        })
        .catch((res: any) => {
          setLoading(false);
          handleAfterClick(res);
        });      
      }
      else{
        // option1
        const res:any = {
            "isError": false,
            "isCaptchaNeeded": false,
            "otpDestMasked": "UB2:xxxxxxxxxxx6511",
            "maskedEmail": "d****e@d******.gov.il",
            "currentState": "loginGetOTPInput",
            "isPasskeyEnrolled": false
        };
        handleAfterClick(res);  
        
        // option2
        // const res:any = {
        //   "isError": true,
        //   "isCaptchaNeeded": true,
        //   //"errorCode": "N_General_Error_PUSH_NOTIFICATIONS_simID_OR_deviceID_DO_NOT_MATCH",
        //   "errorCode": "N_General_Error_AUTH_REJECTED",
	      //   "maskedEmail": "d****e@d******.gov.il",
        //   "currentState": "loginGetUsernamePasswordInput",
        //   "isPasskeyEnrolled": false
        // };
        // handleAfterClick(res);  
            
      }     
   };
    
  //  const onSolve = (userId: string, password: string, captchaResult: string): any => {     
  //    return new Promise((resolve, reject) => {
  //      Ajax.FirstLoginSMS(userId, password, captchaResult)
  //        .then((res: any) => {
  //          setLoading(false);
  //          resolve(res);
  //        })
  //        .catch((error) => {
  //          setLoading(false);
  //          reject(error);
  //        });
  //    });
  //  };
    
  const handleAfterClick = (res: any) => {    
    if(res){  
      if (res.isError) {  
        if(res.errorCode === "ERROR_UB_AUTH_FAILED_FALLBACK_SMS") {
          setMaskOtpDest(res.otpDestMasked.substring(2)); 
          setMaskEmailDest(res.maskedEmail);
          props.updateLoginStage(2);
          setStage(2);  
        }
        else{
          setServerMessage(Translate("N_General_Error_" + res.errorCode) !== '' ? Translate("N_General_Error_" + res.errorCode) : Translate('N_General_Error_SYSTEM_ERROR'));  
        }                               
      } 
      else {     
        if(res.otpDestMasked.startsWith("UB:")){
          props.updateLoginStage(3);
          setStage(3); 
        }
        else if(res.otpDestMasked.startsWith("UB2:")){
          props.updateLoginStage(4);
          setStage(4); 
        }
        else{
          setMaskOtpDest(res.otpDestMasked.substring(2)); 
          setMaskEmailDest(res.maskedEmail);
          props.updateLoginStage(2);
          setStage(2); 
        }                 
      }
    }
    else{
      setServerMessage(Translate('N_General_Error_SYSTEM_ERROR'));
    }  
  };

  const handleUserId = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[0-9]{0,9}$/;
    const digitsOnly = e.target.value.toString().replace(/-/g,'');
    if (regex.test(digitsOnly)) {     
      setUserId(digitsOnly); 
      if(Validator.IdIsValide(digitsOnly)){
        document.getElementById("userId")?.setAttribute("aria-invalid","false");
      } 
      else{
        document.getElementById("userId")?.setAttribute("aria-invalid","true");
      } 
    }      
  };

  const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value); 
    
    if(Validator.IsValidPassword(e.target.value)){
      document.getElementById("userPass")?.setAttribute("aria-invalid","false");
    }
    else{
      document.getElementById("userPass")?.setAttribute("aria-invalid","true");
    }
  };

  const handleEnter = (event) => {    
    if (event.charCode === 13) {
      event.preventDefault();
      Submit();
    }
  };

  const isIdValid = () => {
    
    return Validator.IdIsValide(userId);
  };

  const idLengthValidation = () => {
    if(userId.length === 0 || userId.length === 9){
      return true;
    }
    else{
      return false;
    }
  }

  const idValidationMessage = () => {
    if(userId.length===0)
    {
      return Translate('N_General_Error_Mandatory_Field')
    } 
    else if(userId.length<9)
    {
      return Translate('N_General_Error_ID_NUMBER_TOO_SHORT'); 
    }
    else{
      return Translate('N_General_Error_INVALID_ISRAELI_ID_NUM');
    }    
  };

  const isPasswordValid = () => {
    return Validator.IsValidPassword(password);
  };

  const passwordValidationMessage = () => {
    return password.length === 0
      ? Translate('N_General_Error_Mandatory_Field')
      : Translate('N_General_Error_Password_UnknownValidation');
  };

  const handleIDBlur = ()=>
  {
    setIdBlur(true);   
  };

  const handleIDFocus = ()=>
  {
    setIdBlur(false);
  };

  const onOtpCompleted = (neededInfo:any) => {
    if(neededInfo === undefined || neededInfo[0].trim().length === 0){
      //Send request to server to check for keys defined. if not show this market form
      if (!ctx.devMode){
        if(_loginType !== _loginTypeSMSOTPSmartphoneEnrollment){
          setLoading(true);
          Ajax.CheckEnrolledPasskeys()
            .then((res: any) => {
              setLoading(false);
              if (!res.isPasskeyEnrolled || (sessionStorage.getItem('showPkBtn') !== undefined && sessionStorage.getItem('showPkBtn') === 'false'))
              {
                if(localStorage.getItem('showPkMarket') === null || 
                    localStorage.getItem('showPkMarket') === "true" ||
                    (localStorage.getItem('showPkMarket') === "false" && sessionStorage.getItem('showPkBtn') !== undefined && sessionStorage.getItem('showPkBtn') === 'false')
                  ){
                  ctx.passkeyMarketSelected();
                }
                else{
                  localStorage.setItem('preferredLoginType', _loginTypeSMSOTP ); 
                  sessionStorage.removeItem('showPkBtn');
                  ctx.setSuccess();
                }              
              }
              else{
                localStorage.setItem('preferredLoginType', _loginTypeSMSOTP ); 
                sessionStorage.removeItem('showPkBtn');
                ctx.setSuccess();
              }               
            })
            .catch((error) => {
              setLoading(false);
              setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));  
            });
        }       
      }
      else{
        localStorage.setItem('preferredLoginType', _loginTypeSMSOTP );
        if(localStorage.getItem('showPkMarket') === null || localStorage.getItem('showPkMarket') === "true" ){
          ctx.passkeyMarketSelected();
        }
        else{
          ctx.setSuccess();
        }         
      }
            
      //if there are keys defined, show list of keys.

      
      //*** show success component */
      // setShouldShowSuccess(true);
      // ctx.setSuccess();
    }   
    else if (neededInfo.length > 0) {      
      ctx.setLoginNeededInfo(neededInfo);
    }            
  };
  
  const setPasswordToolTipShow = (e:any) => {       
    setPasswordToolTip(true);
  }

  const setPasswordToolTipHide = (e:any) => {
    setPasswordToolTip(false);
  }

  const handlePasswordAutoFill = (e: React.AnimationEvent<HTMLInputElement>) => {
    setIsPasswordAutofilled(e.animationName === 'onAutoFillStart');
  };
   
  const handleAppClick = () => {        
    window.location = _loginMethodSmartphoneOtpUrl;
  };

  const handleControlTypePress=(event) =>{
    if (event.charCode === 13 || event.charCode === 32)
    {
      setControlType(
        controlType === 'password'
          ? 'text'
          : 'password'
      );
    }
  };

  const onForgotPassHandler = () => {
    window.location.href = `${_siteSettings.forgottenPasswordLink}&locale=${_curLang}`;
  };

  const onForgotPassPress = (event) => {
    event.preventDefault();
    if (event.charCode === 13 || event.charCode === 32){
      onForgotPassHandler();  
    }
  }

  const handlekeyPassClick = () => {            
    window.location = _loginMethodWebauthnUrl;
  };

  const updateStage = (newStage:number) => {
    props.updateLoginStage(newStage);
    setStage(newStage);
  };

  const onExpiredHandler = (step:number) => {
    console.log(step);
    setTimeoutStep(step);
    setStage(6);
  }

  const onRejectHandler = () => {
    setStage(7);
  };

  const redirectToSmsHandler = (mobileMasked:string, mailMasked:string) => {
    setMaskOtpDest(mobileMasked);
    setMaskEmailDest(mailMasked);
    setStage(2);
  };

  const onSimOrDeviceChangedHandler = (mailMasked:string) => {
    setMaskEmailDest(mailMasked);
    setStage(5);
  };    

  return (
    <React.Fragment>
      <GovSpinner show={loading} />
      
      {/* <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={_siteSettings.recaptchaSiteKey}
        onChange={callback}
        onExpired={onCaptchaExpired}
        size='invisible'
      /> */}
      
     
      {stage === 1 && (
          <div className='login-wrapper'>                   
            <form className={`normal-form ${props.isLandingPage ?'login-form' : 'login-form-only' }`}> 

              {!ctx.isAccount &&
                <div className="up_note_tablet">
                  <LoginSideNote />
                  <div className="up_note_tablet_break_line"></div>
                </div> 
              }

              <div className='loginHeading'>
                <img
                  className=''
                  src={passwordImg}                  
                  width={44}
                  height={32}
                  alt=""
                  aria-hidden="true"
                />                
                <div className='title mt-1'>{Translate('N_Login_password_title')}</div>                               
              </div>                  
                                         
              <div className='loginFormZone' >                
                <div id='idDiv' >
                  <div>   
                    <label htmlFor='userId'>                             
                      <span>{Translate('N_General_SignUp_info_3')}</span>&nbsp;
                      <span className='note'>
                          {Translate('N_General_SignUp_info_3_brackets')}
                      </span> 
                    </label>                
                  </div>
                  <div>
                    {/* <MaskedInput
                      type='tel'
                      id='userId'
                      autoComplete='off'
                      aria-required="true"
                      mask={[/\d/, /\d/, /\d/, /\d/,/\d/, /\d/, /\d/, /\d/, /\d/]}
                      placeholder="_________"
                      value={userId}
                      onChange={handleUserId}
                      onKeyPress={handleEnter} 
                      onBlur={handleIDBlur} 
                      onFocus={handleIDFocus}
                      aria-invalid="false"
                      aria-errormessage="idError"   
                      className={`form-control
                        ${(!isIdValid() && idLengthValidation() && idDirty) ?
                          ' error-control' : ''
                        }
                      `}                                    
                      /> */}
                      <MaskInput
                        type="tel"
                        id="userId"
                        autoComplete="off"
                        ariaRequired={true}
                        ariaInvalid={(!isIdValid() && idLengthValidation() && idDirty) ? true : false}
                        ariaErrormessage="idError"
                        mask="000000000"   // 9 digits
                        placeholder="-"
                        value={userId}
                        onChange={(val) => 
                          handleUserId({ 
                            target: { value: val } 
                          } as React.ChangeEvent<HTMLInputElement>)
                        }
                        onKeyPress={handleEnter}
                        onBlur={handleIDBlur}
                        onFocus={handleIDFocus}
                        className={`form-control ${(!isIdValid() && idLengthValidation() && idDirty) ? 'error-control' : ''}`}
                      />
                  </div>
                  {!isIdValid() && idDirty &&  (idLengthValidation() || idBlur) && (
                    <div className='d-flex align-items-center'>
                      <img src={alert}  className='error-alert' alt=""/>
                      &nbsp;
                      <span id='idError' className='small error'>
                        {idValidationMessage()}
                      </span>
                    </div>
                  )}
                </div>
                <div id='passwordDiv' className='position-relative'>
                    <div className='mt-2 d-flex align-items-center justify-content-between'>
                      <div className='d-flex align-items-center'>
                        <label id='pwd_label' htmlFor='userPass'>{Translate('N_General_SignUp_info_12')}</label>                        
                      </div>
                      {/* {!isPasswordAutofilled &&  */}
                      <div 
                        className='d-flex align-items-center'
                        aria-hidden="true"
                        onClick={() =>
                          setControlType(
                            controlType === 'password'
                              ? 'text'
                              : 'password'
                          )
                        } 
                        onKeyPress={handleControlTypePress}                       
                      >
                        <img
                          src={controlType === 'password' ? eye : eyeOff}
                          width='22px'
                          height='18px'
                          
                          role='button'
                          tabIndex={0}
                          className={
                            password
                              ? 'mx-1 password-view-show'
                              : 'mx-1 password-view-hide'
                          }
                          alt=""
                        />
                        <span 
                          className={
                            password
                              ? 'password-view-show'
                              : 'password-view-hide'
                          }
                          tabIndex={0}
                        >
                          {controlType === 'password' 
                            ? Translate('N_General_SignUp_info_18')
                            : Translate('N_General_SignUp_info_19')
                          }
                        </span>                        
                        
                      </div>
                      {/* } */}
                    </div>
                    <input
                      type={controlType}
                      value={password}
                      id='userPass'
                      aria-required="true"                      
                      onChange={handlePassword}
                      onKeyPress={handleEnter}
                      onFocus = {setPasswordToolTipShow}
                      onBlur = {setPasswordToolTipHide}
                      onAnimationStart={handlePasswordAutoFill}
                      aria-invalid="false"
                      aria-errormessage="passError"
                      className={`form-control userPassword gov-black
                        ${!isPasswordValid() && passwordDirty
                          ? ' error-control'
                          : ''
                        }
                      `}
                    />
                 
                    {!isPasswordValid() && passwordDirty && (
                      <div className='d-flex align-items-center'>
                        <img src={alert}  className='error-alert' />
                        &nbsp;
                        <span id="passError" className='small error'>
                          {passwordValidationMessage()}
                        </span>
                      </div>
                    )}

                    {
                    passwordTooltip && 
                    <div className="passwordInstructionTooltip">
                      {Translate('N_Login_password_instruction')}
                      <ul>
                        <li>{Translate('N_Login_password_instruction_1')}</li>
                        <li>{Translate('N_Login_password_instruction_2')}</li>
                        <li>{Translate('N_Login_password_instruction_3')}</li>
                        <li>{Translate('N_Login_password_instruction_4')}</li>
                        
                      </ul>
                    
                    </div>
                    }
                </div>
                
                <div className='mt-2'>
                  <a
                    id='toForgotPass'
                    className='link fontBold'
                    onClick={onForgotPassHandler}
                    onKeyPress={onForgotPassPress}
                    tabIndex={0}                    
                  >
                    {Translate('N_Login_password_forgot_password')}
                  </a>
                </div>
                {serverMessage.length > 0 && (
                  <Toast message={serverMessage} />
                )}
                <div className={!showPassKey ? 'submit-mobile-no-pssky' : '' }>
                  <SubmitBtn
                    title={Translate('N_Login_password_login_button')}
                    id="loginSubmit"
                    action={Submit}
                    showIcon={true}
                    disabled={!isPasswordValid() || !isIdValid() }
                  />
                </div>

                {/* Dynamic Text */}
                <div className="login_dynamic_text_container">
                    <DynamicText page="otp"/>
                </div>

                {/* redirect to passkey login */}
                <div className='mobile-login-types'>
                  { showPassKey &&
                    <>
                      <div className='otherLoginTypesTitle'>
                        <span>{Translate('N_General_More_Login_Types')}</span>
                      </div>
                  
                      <div className='otherLoginTypesContainer' >
                        <div className='loginOption' onClick={handlekeyPassClick}>
                          <img
                            className='nav-btn-image'
                            src={passkeyImg}
                            alt=""
                          />
                          <span>{Translate('N_Login_Quick_Entry')}</span>
                        </div>                       
                      </div> 
                    </>
                  }

                  {props.isLandingPage && <LoginSideNote /> }
                  
                </div>

                   {/* {isPasswordAutofilled ? 
                      <h2>Password Auto filled</h2> 
                      :
                      <h2>Password Typed</h2> 
                    } */}

                <NavigationButtons/>
                
              </div>              
            </form> 
            {props.isLandingPage &&   
              <>             
                <div className="loginBreakeLine"></div>              
                                    
                <div className="loginSideNoteComponent"> 
                  <LoginSideNote />
                </div>              
              </>
            }                                 
          </div>                                    
      )} 
          
      {stage === 2 && (
        <SMSOTP
          setStage={updateStage}
          maskOtpDest={maskOtpDest}
          maskedEmail={maskEmailDest}
          Success={onOtpCompleted}                           
        />
      )}

      {stage === 3 && (
        <PushNotifications 
          isNewUser = {false}
          onExpired = {onExpiredHandler} 
          onReject={onRejectHandler} 
          Success={onOtpCompleted} 
          redirectToSms={redirectToSmsHandler}
          onSimOrDeviceChanged={onSimOrDeviceChangedHandler}
        />
      )}

      {stage === 4 && (
        <PushNotifications 
          isNewUser = {true}
          onExpired = {onExpiredHandler} 
          onReject={onRejectHandler} 
          Success={onOtpCompleted} 
          redirectToSms={redirectToSmsHandler}
          onSimOrDeviceChanged={onSimOrDeviceChangedHandler}
        />
      )}

      {/* {stage === 3 && (
        <PushDetailsExists 
          onExpired = {onExpiredHandler} 
          onReject={onRejectHandler} 
          Success={onOtpCompleted} 
          redirectToSms={redirectToSmsHandler}
          onSimOrDeviceChanged={onSimOrDeviceChangedHandler}
        />
      )}

      {stage === 4 && (
        <PushDetailsNotExists 
          onExpired = {onExpiredHandler} 
          onReject={onRejectHandler} 
          Success={onOtpCompleted} 
          redirectToSms={redirectToSmsHandler}
          onSimOrDeviceChanged={onSimOrDeviceChangedHandler}
        />
      )} */}

      {stage === 5 && (
        <PushVerification maskedEmail={maskEmailDest}/>
      )}
      
      {stage === 6 && (
        <PushTimeout step = {timeoutStep}/>
      )}

      {stage === 7 && (
        <PushCancel />
      )}
                                   
    </React.Fragment>
  );

};
export default Login;

